import { SET_EMPLOYEES_WORKOUT_WATCHTIME, SET_NUMBER_OF_EMPLOYEES, SET_TEAM_FAVORITE_WORKOUT } from "./types";

const initialState = {
    empoloyeesWorkoutWatchtime: [],
    favoriteWorkouts: [],
    numberOfEmployees: 0
};

export default function (state = initialState, action) {

    switch (action.type) {
        case SET_EMPLOYEES_WORKOUT_WATCHTIME:
            return {
                ...state,
                empoloyeesWorkoutWatchtime: action.data
            }

        case SET_NUMBER_OF_EMPLOYEES:
            return {
                ...state,
                numberOfEmployees: action.data
            }

        case SET_TEAM_FAVORITE_WORKOUT:
            return {
                ...state,
                favoriteWorkouts: action.data
            }

        default:
            return state;
    }
}